/**
 * Yol tabanli site ici arama tespiti.
 *
 * Bazi siteler arama sorgusunu query parametresinde degil yolun icinde tasir:
 *   /arama/iphone%2018/   /search/laptop   /ara/kulaklik/?sayfa=2
 * Kalip formati: "/arama/*" (veya "/arama/{q}"); "*" sorgunun bulundugu
 * segmenttir. Kaliptaki sabit segmentler buyuk/kucuk harf duyarsiz eslesir.
 *
 * Bu dosyanin iki kopyasi vardir ve birlikte guncellenir:
 *   visitor/static/src/tracker/collectors/searchPath.js  (tracker, ES module)
 *   tablet/services/webAnalytics/searchPath.js           (heuristicPageType, CommonJS)
 */

// Ayarda liste bos olsa bile taninan yaygin arama yollari (cok dilli)
var DEFAULT_SEARCH_PATHS = [
    "/arama/*",
    "/ara/*",
    "/arama-sonuclari/*",
    "/search/*",
    "/search-results/*",
    "/results/*",
    "/find/*",
    "/suche/*",
    "/recherche/*",
    "/busqueda/*",
    "/buscar/*",
    "/ricerca/*",
    "/cerca/*",
    "/zoeken/*",
    "/поиск/*",
    "/pesquisa/*",
    "/szukaj/*",
];

var PLACEHOLDERS = { "*": true, "{q}": true, "{query}": true, ":q": true, ":query": true };

function splitSegments(value) {
    return String(value || "")
        .split("/")
        .filter(function (part) {
            return part.length > 0;
        });
}

function decodeSegment(value) {
    var text = String(value || "");
    try {
        text = decodeURIComponent(text);
    } catch (e) {
        /* bozuk encoding: ham deger kullanilir */
    }
    return text
        .replace(/[+_-]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();
}

/**
 * @param {String} pathname  (query string'siz yol)
 * @param {Array<String>} patterns site ayari; bos/verilmezse varsayilanlar
 * @returns {String} arama sorgusu (eslesme yoksa "")
 */
function extractSearchFromPath(pathname, patterns) {
    var list = Array.isArray(patterns) && patterns.length > 0 ? patterns : DEFAULT_SEARCH_PATHS;
    var pathSegments = splitSegments(pathname);
    if (pathSegments.length === 0) return "";

    for (var i = 0; i < list.length; i++) {
        var patternSegments = splitSegments(String(list[i] || "").toLowerCase());
        if (patternSegments.length === 0) continue;

        var matched = true;
        var query = "";
        for (var s = 0; s < patternSegments.length; s++) {
            var expected = patternSegments[s];
            var actual = pathSegments[s];
            if (actual === undefined) {
                matched = false;
                break;
            }
            if (PLACEHOLDERS[expected]) {
                query = decodeSegment(actual);
                continue;
            }
            var decodedActual = actual;
            try {
                decodedActual = decodeURIComponent(actual);
            } catch (e) {
                /* ham deger */
            }
            if (decodedActual.toLowerCase() !== expected) {
                matched = false;
                break;
            }
        }
        if (!matched) continue;

        // Kalipta yer tutucu yoksa ("/arama") sorgu bir sonraki segmenttir
        if (!query && patternSegments.length < pathSegments.length && !hasPlaceholder(patternSegments)) {
            query = decodeSegment(pathSegments[patternSegments.length]);
        }
        if (query && query.length <= 200) return query;
    }
    return "";
}

function hasPlaceholder(segments) {
    for (var i = 0; i < segments.length; i++) {
        if (PLACEHOLDERS[segments[i]]) return true;
    }
    return false;
}

/** Ayardan gelen kalip gecerli mi (panel/updateSetting dogrulamasi). */
function isValidSearchPath(value) {
    if (typeof value !== "string") return false;
    var text = value.trim();
    return text.length > 1 && text.length <= 200 && text.charAt(0) === "/";
}

export { extractSearchFromPath, isValidSearchPath, DEFAULT_SEARCH_PATHS };
export default extractSearchFromPath;



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/collectors/searchPath.js
// module id = null
// module chunks = 